// extracted by mini-css-extract-plugin
export default {"Input":"Input_Input__5UTQn","invalid":"Input_invalid__ks-zL"};